import { Component, OnInit, ElementRef } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { SettingsService } from 'src/app/services/settings.service';
import { UserService } from 'src/app/services/user.service';
import { UserRole } from 'src/app/shared/models/users/user-role';

@Component({
  selector: 'app-external-navbar',
  templateUrl: './external-navbar.component.html',
  styleUrls: ['./external-navbar.component.scss']
})
export class ExternalNavbarComponent implements OnInit {

  constructor(private router: Router, private userService: UserService, public settingsService: SettingsService) {

  }

  async ngOnInit() {
    console.log("External Nav");
  }

  ngDoCheck() {
    this.router.events.subscribe((e) => {
      if (e instanceof NavigationStart) {
        if (e.url === "/settings" || e.url === "/broker-account") {
          //this.showTextInHeader = true;
          //this.headerText = e.url === "/settings" ? "Settings" : "Manage Broker Users";
        } else {
          //this.showTextInHeader = false;
        }
      }
    })
  }

}

